import { render } from "./LikeIcon.vue?vue&type=template&id=844a9484"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/LikeIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "844a9484"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('844a9484', __exports__)) {
    api.reload('844a9484', __exports__)
  }
  
  module.hot.accept("./LikeIcon.vue?vue&type=template&id=844a9484", () => {
    api.rerender('844a9484', render)
  })

}


export default __exports__